import { KeyframeConfig } from "../../../models/animations.model";

export const getFadeInBaseKeyframe = (opacity: number): KeyframeConfig[] => {
  return [{ option: { keyframes: [{ opacity: 0 }, { opacity: opacity }] } }];
};

export const getFadeOutBaseKeyframe = (opacity: number): KeyframeConfig[] => {
  return [{ option: { keyframes: [{ opacity: opacity }, { opacity: 0 }] } }];
};
